import Model from 'src/app/common/model';
import ItemMasterModel from './itemMaster.model';
import Vendors from './vendor.model';
import FarmSiteModel from './farmSite.model';

// work on this model
export default class PaymentTransactionModel extends Model {
  ItemMaster: ItemMasterModel;
  Vendor: Vendors;
  farmSite: Array<FarmSiteModel>;
  vendor_id?: number;
  invoice_number?: string;
  item_id?: Array<string>;
  business_id?: string;
  farm_site_id?: string | number;
  paid_date?: string;
  paid_amount?: number;
  invoice_id?: number;
  payment_status?: PaymentStatus;
  purchase_amount?: number;
  unpaid_amount?: number;
  as_of_date?: string;
  date: string;
  transaction_type_id?: string | number;
  return_amount?: number;
  received_amount?: number | string;
  from_date?: string;
  to_date?: string | number;
  filePath?: string;
  purchaseAmount?: number;
  paidAmount?: number;
  returnAmount?: number;
  material_transaction_id?: any;
  vendor_payment_transaction_id: string | number;
  value?: Array<string>;
  quantity: Array<string>;
  uom_id: Array<string>;
  order: string;
  orderWithUpdatedAt: string;
  page: number;
  limit: number;
  updatedAt: any;
  businessName: string;
  farmNameAtLocation: string;

  constructor() {
    super();
  }
}

export type PaymentStatus = 'Partially' | 'Fully';
